export default __webpack_public_path__ + "static/media/submittedCompany.3d878e09.svg";